import React, { useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from '../store/useAuthStore';
import { getCurrentUser } from '../api/productService';

const ProtectedRoute: React.FC = () => {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const location = useLocation();
  const [pinCheckLoading, setPinCheckLoading] = useState(true);
  const [isPinSetUp, setIsPinSetUp] = useState<boolean | null>(null);

  useEffect(() => {
    const checkPinSetup = async () => {
      if (!isAuthenticated) {
        setPinCheckLoading(false);
        return;
      }

      // Skip PIN check if already on PIN setup pages
      if (location.pathname === '/pin' || location.pathname === '/confirm-pin') {
        setPinCheckLoading(false);
        setIsPinSetUp(true); // Allow access to PIN setup pages
        return;
      }

      try {
        const userData = await getCurrentUser();
        setIsPinSetUp(userData.user.isPinSetUp);
      } catch (error) {
        console.error('Error checking PIN setup:', error);
        setIsPinSetUp(true); // Allow access on error to prevent blocking
      } finally {
        setPinCheckLoading(false);
      }
    };

    checkPinSetup();
  }, [isAuthenticated, location.pathname]);

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (pinCheckLoading) {
    return <div></div>;
  }

  if (isPinSetUp === false) {
    return <Navigate to="/pin" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
